import React from 'react';

import MuiProgressCircular, {
  CircularProgressProps as MuiProgressCircularProps,
} from '@mui/material/CircularProgress';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const ProgressCircular = withCoreProps<ProgressCircularProps>(
  ({ className, ...props }: React.PropsWithChildren<ProgressCircularProps>) => {
    const clsxClass = clsx(className);

    return <MuiProgressCircular {...props} className={clsxClass} />;
  },
);

export interface ProgressCircularProps
  extends MuiProgressCircularProps,
    CoreProps {}
